// extracted by mini-css-extract-plugin
export default {"cls1":"eBWNJderXwj8015q9SBs","cls2":"zy5qNHQqwH8ftlx1tVHh eBWNJderXwj8015q9SBs","isTabletDown":"e5ThXxFPCWDQrED2jBAc","isPhone":"T9Qvv2R4g40IqsSg4lgR"};